import Receipt from "./receipt.view";

export default Receipt;
